import * as THREE from 'three'
import React, { Ref, useEffect, useRef, useState } from 'react'
import { Group, Object3D } from 'three'
import { useModel } from '../../../models/ModelJack'

const Jack = ({
  // animations with skeleton used to attack/replace body parts.
  // If original model body is used as it is, elements are not in place.
  // ModelSkeletor is a model with parts fixed to match anim skeleton.
  nodesSrc,
  ...props
}: { nodesSrc?: Record<string, Object3D> } & JSX.IntrinsicElements['group']) => {
  const [clonedNodes, setClonedNodes] = useState<Record<string, unknown>>()
  const group = useRef<THREE.Group>()

  const { nodes } = useModel()

  useEffect(() => {
    if (nodes) {
      // const clonedNodes = { Body: nodesSrc!.Body.clone() }
      // clonedNodes.Body.add(nodes.character_skeleton_minion_body.clone())
      // clonedNodes.Body.children.find(n => n.name === 'armRight')?.add(nodes.character_skeleton_minion_armRight.clone())
      // clonedNodes.Body.children.find(n => n.name === 'armLeft')?.add(nodes.character_skeleton_minion_armLeft.clone())
      // clonedNodes.Body.children.find(n => n.name === 'Head')?.add(nodes.character_skeleton_minion_head.clone())

      setClonedNodes(nodes)
    }
  }, [nodes])
  return (
    <group ref={group as Ref<Group>} {...props} dispose={null} name="Jack">
      {clonedNodes && <primitive object={clonedNodes.character_jack} />}
    </group>
  )
}
export default React.memo(Jack)
